import { render, staticRenderFns } from "./inspection-approval-modal.vue?vue&type=template&id=634dbf3b&scoped=true&"
import script from "./inspection-approval-modal.vue?vue&type=script&lang=js&"
export * from "./inspection-approval-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634dbf3b",
  null
  
)

export default component.exports